"use client"

import { useSyncExternalStore } from "react"

const overlays = new Set<symbol>()
const listeners = new Set<() => void>()
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener) } }
const snapshot = () => overlays.size > 0
const serverSnapshot = () => false

/** Register the visible fullscreen layer, including programmatic opens and unmounts. */
export function registerFullscreenSupport() {
  const id = Symbol()
  overlays.add(id)
  listeners.forEach(listener => listener())
  return () => { overlays.delete(id); listeners.forEach(listener => listener()) }
}

export function useFullscreenSupportOpen() {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot)
}
